import React, { useEffect, useRef, useState } from 'react'
import './leave-application.css'
import CloseIcon from '@mui/icons-material/Close';
import { Controller, useForm } from 'react-hook-form';
import { Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField, TextareaAutosize } from '@mui/material';
import { userleaveDetails } from '../../services/constant'
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Dispatch } from 'redux';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { DateValidationError } from '@mui/x-date-pickers/models';
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { postLeaveApply, uploadLeaveAttachment, editEmployeeDetails, getNoOfLeaveDay, getHoliday, getAllLeaveOfEmployee, getEmployeeLeaveDetails } from '../../api-services/employee-services';
import jwt from 'jwt-decode';
import { JwtModel } from '../../model/token-model/token.model';
import dayjs from 'dayjs';
import { SnackbarService } from '../../services/snackBehaviorSubject/snackBehaviorSubject';
import { AiFillCloseCircle } from 'react-icons/ai';
import ButtonWrapper from '../../widgets/button/button';
import { TokenService } from '../../services/token.service';




interface leaveDetails {
    leaveType: string,
}

interface fieldValueProps {
    leaveType: string,
    session: string,
    fromDate: string,
    toDate: string,
    noOfDays: number,
    attachment: null,
    name: string,
    reasonForLeave: string,
    leavePeriod: string,
    employeeTag: string,
}
interface LeaveApplicationProps {
    onClose: () => void;
    isFullPage?: boolean;
}

const LeaveApplication = (props: LeaveApplicationProps) => {
    const state = useSelector((state: any) => state.configuration)
    const snackbarService = SnackbarService()
    const [leveDetails, setLeaveDetails] = useState<leaveDetails[]>([])
    const { control, handleSubmit, setValue, register } = useForm();
    const extractToken = TokenService.extractToken()
    const leaveDetails = userleaveDetails();
    const [file, setFile] = useState<File>()
    const [holidays, setHolidays] = useState<any[]>([]);
    const [hasPendingLeave, setHasPendingLeave] = useState<boolean>(false);
    const [userBalances, setUserBalances] = useState<any[]>([]);

    const [fieldValue, setFieldValue] = useState<fieldValueProps>({
        leaveType: "",
        session: "",
        fromDate: "",
        toDate: "",
        name: '',
        noOfDays: 0,
        leavePeriod: "",
        attachment: null,
        reasonForLeave: "",
        employeeTag: ""
    })
    // Casual or Special leave must be applied at least 24 hours in advance (requires 1 full clear day before start). Medical has no restriction.
    const minSelectableDate = (fieldValue.leaveType === 'Casual' || fieldValue.leaveType === 'Special') ? dayjs().add(1, 'day') : undefined;
    const maxDayOfStartDay = fieldValue.leaveType === 'Special' ? undefined : (fieldValue.toDate !== '' ? dayjs(fieldValue.toDate) : undefined);
    const minDateOfToDate = dayjs(fieldValue.fromDate)

    useEffect(() => {
        getHoliday().then((res: any) => {
            if (res?.data?.success) setHolidays(res.data.payload || []);
        }).catch(() => {});

        getAllLeaveOfEmployee(extractToken?.sub).then((res: any) => {
            if (res?.data?.success) {
                const pending = res.data.payload.some((l: any) => l.leaveStatus === 'Pending');
                setHasPendingLeave(pending);
            }
        }).catch(() => {});

        getEmployeeLeaveDetails(extractToken?.sub).then((res: any) => {
            if (res?.data?.success) {
                const updatedPayload = (res.data.payload || []).map((item: any) => {
                    let maxLeave = 0;
                    if (item.leaveType?.toLowerCase().includes('casual')) maxLeave = item.leaveBreaks.earned;
                    else if (item.leaveType?.toLowerCase().includes('medical') || item.leaveType?.toLowerCase().includes('sick')) maxLeave = item.leaveBreaks.earned;
                    else if (item.leaveType?.toLowerCase().includes('special')) maxLeave = item.leaveBreaks.earned;

                    if (maxLeave > 0) {
                        const origMax = Number(item.leaveBreaks.earned || 0) + Number(item.leaveBreaks.entitled || 0) + Number(item.leaveBreaks.carriedOver || 0);
                        const origTaken = origMax - Number(item.leaveBreaks.balance || 0);
                        
                        item.leaveBreaks.earned = maxLeave;
                        item.leaveBreaks.entitled = 0;
                        item.leaveBreaks.carriedOver = 0;
                        item.leaveBreaks.balance = maxLeave - origTaken;
                        if (item.leaveBreaks.balance < 0) item.leaveBreaks.balance = 0;
                    }
                    return item;
                });
                setUserBalances(updatedPayload);
            }
        }).catch(() => {});
    }, [extractToken?.sub]);

    const shouldDisableDate = (date: dayjs.Dayjs) => {
        const month = date.month(); // 0-indexed (0 = Jan, 11 = Dec)
        const day = date.date();
        
        const isAug15 = (month === 7 && day === 15);
        const isOct2 = (month === 9 && day === 2);
        const isDec25 = (month === 11 && day === 25);
        
        return isAug15 || isOct2 || isDec25;
    };

    useEffect(() => {

        const matchingLeaves = leaveDetails.filter(getItem =>
            state.leave_config.some((item: any) => item.id === getItem.id)
        );

        console.log(matchingLeaves);
        setLeaveDetails(matchingLeaves)
    }, [state.leave_config])

    useEffect(() => {
        if (fieldValue.leaveType === "Special") {
            if (fieldValue.fromDate !== "") {
                const days = fieldValue.session === "Half Day" ? "0.5" : "1";
                setValue("noOfDays", days);
                setFieldValue((d: any) => ({ ...d, noOfDays: days }));
            }
            return;
        }

        if (fieldValue.fromDate !== "" && fieldValue.toDate !== "") {
            const start = new Date(fieldValue.fromDate);
            const end = new Date(fieldValue.toDate);
            start.setHours(0, 0, 0, 0);
            end.setHours(0, 0, 0, 0);
            getNoOfLeaveDay(fieldValue.fromDate, fieldValue.toDate).then((response: any) => {
                if (response?.data) {
                    setValue("noOfDays", response.data)
                    setFieldValue((d: any) => {
                        return { ...d, ["noOfDays"]: response.data }
                    })
                }
            })
        }
    }, [fieldValue.fromDate, fieldValue.toDate, fieldValue.leaveType, fieldValue.session])

    useEffect(() => {
        if (fieldValue.leaveType === "Special") {
            return;
        }
        if (fieldValue.fromDate !== "" && fieldValue.session === "Half Day") {
            const timeDifference = 1 - 0.5;
            let convertNumToStr = timeDifference.toString()
            setValue("noOfDays", convertNumToStr)
            setFieldValue((d: any) => {
                return { ...d, ["noOfDays"]: convertNumToStr }
            })
        } else {

            setValue("noOfDays", "")
            setFieldValue((d: any) => {
                return { ...d, ["noOfDays"]: "" }
            })
        }
    }, [fieldValue.fromDate, fieldValue.session, fieldValue.leaveType, setValue])

    useEffect(() => {
        if (fieldValue.leaveType === "Special") {
            if (fieldValue.fromDate !== "") {
                if (fieldValue.toDate !== fieldValue.fromDate) {
                    setFieldValue((d: any) => ({ ...d, toDate: fieldValue.fromDate }));
                    setValue("toDate", fieldValue.fromDate);
                }
            } else {
                if (fieldValue.toDate !== "") {
                    setFieldValue((d: any) => ({ ...d, toDate: "" }));
                    setValue("toDate", "");
                }
            }
        }
    }, [fieldValue.leaveType, fieldValue.fromDate, fieldValue.toDate, setValue])
    console.log(fieldValue)

    console.log(file)
    const onSubmit = (data: any) => {
        if (hasPendingLeave) {
            snackbarService.next({ data: { open: true, severity: 'error', message: 'You have a pending leave request. You cannot apply for a new one until it is resolved.' } });
            return;
        }

        const typeBalanceObj = userBalances.find((b: any) => 
            b.leaveType?.toLowerCase().trim() === fieldValue.leaveType?.toLowerCase().trim() ||
            fieldValue.leaveType?.toLowerCase().includes(b.leaveType?.toLowerCase().trim())
        );
        if (typeBalanceObj && Number(fieldValue.noOfDays) > Number(typeBalanceObj.leaveBreaks.balance)) {
            const availableBalance = Number(typeBalanceObj.leaveBreaks.balance);
            const extraDays = Number(fieldValue.noOfDays) - availableBalance;
            snackbarService.next({ data: { open: true, severity: 'error', message: `Requested days exceed your available ${typeBalanceObj.leaveType} balance. You have requested ${extraDays.toFixed(1)} extra days. You can only apply for up to ${availableBalance.toFixed(1)} days.` } });
            return;
        }
        
        if (fieldValue.leaveType === 'Medical' && fieldValue.noOfDays >= 2 && !file) {
            snackbarService.next({ data: { open: true, severity: 'error', message: 'Attachment is mandatory for Medical Leave of 2 or more days.' } });
            return;
        }

        const randomId = Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000;
        data["name"] = extractToken?.name
        data['leaveId'] = randomId
        console.log(file)
        console.log(data)
        if (data.toDate !== 'DD/MM/YYYY' && data.fromDate !== 'DD/MM/YYYY') {
            console.log(data)
            postLeaveApply(data, extractToken?.sub).then((res: any) => {
                if (res?.data.success) {
                    let msg = res.data.message;
                    if (msg && msg.toLowerCase().includes("remaining balance")) {
                        const typeBalanceObj = userBalances.find((b: any) => 
                            b.leaveType?.toLowerCase().trim() === fieldValue.leaveType?.toLowerCase().trim() ||
                            fieldValue.leaveType?.toLowerCase().includes(b.leaveType?.toLowerCase().trim())
                        );
                        let newBalance = typeBalanceObj ? Number(typeBalanceObj.leaveBreaks.balance) - Number(fieldValue.noOfDays) : 0;
                        if (newBalance < 0) newBalance = 0;
                        msg = `You have applied for ${fieldValue.noOfDays} day(s) of leave. Your remaining balance is ${newBalance.toFixed(1)} days.`;
                    }
                    if (fieldValue.leaveType === 'Medical' && file) {
                        uploadLeaveAttachment(randomId, file).then((response: any) => {
                            if (response.data.success) {
                                snackbarService.next({ data: { open: true, severity: 'success', message: msg } })
                            }
                        })
                    }
                    snackbarService.next({ data: { open: true, severity: 'success', message: msg } })
                }

            }
            ).catch()

            setFieldValue({
                leaveType: "",
                session: "",
                fromDate: "",
                toDate: "",
                name: '',
                noOfDays: 0,
                leavePeriod: "",
                attachment: null,
                reasonForLeave: "",
                employeeTag: ""
            })
            setValue('session', '')
            setValue('fromDate', '')
            setValue('id', '')
            setValue('noOfDays', '')
            setValue('attachment', '')
            setValue('reasonForLeave', '')
        } else {
            snackbarService.next({ data: { open: true, severity: 'error', message: 'Please select leave application date' } })
        }


    }

    function formatDateToCustomFormat(inputDate: any) {
        const date = new Date(inputDate);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const customFormat = `${year}-${month}-${day}`; return customFormat;
    }

    const handleField = (e: any, field: any, type?: string) => {
        if (type === "date") {
            var value: String = formatDateToCustomFormat(e.$d.toLocaleDateString("en-US")).toString()
        } else if (type === "file") {
            const file = e.target.files[0]
            setFile(file)
            var value: String = file.name
        } else {
            var value: String = e.target.value
        }

        if (value !== "DD-MM-YYYY" || value !== "") {



            setFieldValue((d: any) => {
                return { ...d, [field]: value }
            })
            setValue(field, value)


        } else {
        }
    }
    const setDateValue = (field: any, value: any) => {

    }
    useEffect(() => {
        const startDate = new Date(fieldValue.fromDate)
        const endDate = new Date(fieldValue.toDate)
        console.log(startDate, "Satrtr date", endDate, 'End Date')
    }, [fieldValue.fromDate, fieldValue.toDate])

    const handleFieldFile = (e: any, field: any, type: String) => {
        const file = e.target.files[0]
        var value: String = file.name
        setFieldValue((d: any) => {
            return { ...d, [field]: value }
        })



    }


    return (
        <>
            <div className='main'>

                <form onSubmit={handleSubmit(onSubmit)} className='leave-application-form-container'>

                    <div className='modal-heading'>
                        <h4>Apply Leave</h4>
                        {!props.isFullPage && (
                            <CloseIcon
                                className='modal-close-button'
                                onClick={props.onClose}
                            />
                        )}
                    </div>
                    <div className='tip-message'>Casual or special leave must be applied at least 1 day in advance. Medical leave has no time restrictions.</div>
                    <div className='modal-body padding-top'>
                        <div className='conatiner-100'>
                            <div className={props.isFullPage ? 'full-page-bordered-container' : ''}>
                                <div className={`leave-application-field-container ${props.isFullPage ? 'full-page-fields' : ''}`}>

                                {/* <FormControl required sx={{ minWidth: 120, mb: 2 }} fullWidth> */}
                                    {/* <InputLabel id="employee-tag-label">Employee Tag</InputLabel> */}
                                    {/* <Controller
                                        name="employeeTag"
                                        control={control}
                                        render={({ field }) => (
                                            <Select
                                                name="employeeTag"
                                                labelId="employee-tag-label"
                                                id="employee-tag"
                                                label="Employee Tag *"
                                                defaultValue=""
                                                onChange={(e) => handleField(e, "employeeTag")}
                                                value={fieldValue.employeeTag}
                                            >
                                                <MenuItem value="Engineer">Engineer</MenuItem>
                                                <MenuItem value="Operator">Operator</MenuItem>
                                            </Select>
                                        )}
                                    /> */}
                                {/* </FormControl> */}
                                <FormControl required sx={{ minWidth: 120 }} fullWidth>
                                    <InputLabel id="demo-simple-select-required-label">Leave Type</InputLabel>
                                    <Controller
                                        name="leaveType"
                                        control={control}
                                        render={({ field }) => (
                                            <Select
                                                name="leaveType"
                                                labelId="leave-type-label"
                                                id="leave-type"
                                                label="Leave Type *"
                                                defaultValue=""
                                                onChange={(e) => handleField(e, "leaveType")}
                                                value={fieldValue.leaveType}
                                            >
                                                <MenuItem value="Casual">Casual Leave</MenuItem>
                                                <MenuItem value="Special">Special Leave</MenuItem>
                                                <MenuItem value="Medical">Medical Leave</MenuItem>
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                                <FormControl required sx={{ mt: 1, minWidth: 120 }} fullWidth>
                                    <InputLabel id="demo-simple-select-required-label">Session</InputLabel>
                                    <Controller
                                        name="session"
                                        control={control}
                                        render={({ field }) => (
                                            <>
                                                <Select
                                                    name='session'
                                                    labelId="session-label"
                                                    id="session"
                                                    label="session *"
                                                    onChange={(e) => handleField(e, "session")}
                                                    value={fieldValue.session}
                                                >

                                                    <MenuItem value="Full Day">Full Day </MenuItem>
                                                    {fieldValue.leaveType !== 'Vacation' ? < MenuItem value="Half Day">Half Day </MenuItem> : ''}
                                                </Select>

                                            </>
                                        )}
                                    />
                                </FormControl>

                                {fieldValue.session === "Half Day" && <>
                                    <FormControl required sx={{ mt: 1, minWidth: 120 }} fullWidth>
                                        <Grid container >
                                            <Grid item xs={12}>
                                                <FormControl required fullWidth >
                                                    <InputLabel id="demo-simple-select-required-label">Half Schedule</InputLabel>
                                                    <Controller
                                                        name="Working_Period"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <Select
                                                                {...field}
                                                                labelId="leavePeriod"
                                                                id="leavePeriod"
                                                                label="Working Period *"
                                                                onChange={(e) => handleField(e, "leavePeriod")}
                                                                value={fieldValue.leavePeriod}
                                                                fullWidth
                                                            >
                                                                <MenuItem value="First Half">First Half</MenuItem>
                                                                <MenuItem value="Second Half">Second Half</MenuItem>
                                                            </Select>
                                                        )}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <FormControl required fullWidth >
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DemoContainer components={['DatePicker']}>
                                                            <DatePicker
                                                                {...register("fromDate", {
                                                                    required: 'error message'
                                                                })}
                                                                minDate={minSelectableDate}
                                                                shouldDisableDate={shouldDisableDate}
                                                                label="Date"
                                                                format='DD/MM/YYYY'
                                                                onChange={(e) => handleField(e, "fromDate", "date")}
                                                                value={dayjs(fieldValue.fromDate)}

                                                            />
                                                        </DemoContainer>
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </FormControl>
                                </>}
                                {fieldValue.session === "Full Day" && <>
                                    <div className='leave-application-date-range-container'>
                                        <FormControl required fullWidth >
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DemoContainer
                                                    components={['DatePicker']}
                                                >
                                                    <DatePicker
                                                        {...register("fromDate", {
                                                            required: 'error message'
                                                        })}
                                                        label={fieldValue.leaveType === 'Special' ? 'Date' : 'From Date'}
                                                        minDate={minSelectableDate}
                                                        maxDate={maxDayOfStartDay}
                                                        shouldDisableDate={shouldDisableDate}
                                                        value={dayjs(fieldValue.fromDate)}
                                                        format='DD/MM/YYYY'
                                                        onChange={(e) => handleField(e, 'fromDate', 'date')}
                                                    />
                                                </DemoContainer>
                                            </LocalizationProvider>
                                        </FormControl>
                                        {fieldValue.leaveType !== 'Special' && (
                                            <FormControl required fullWidth >
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DemoContainer
                                                        components={['DatePicker']}
                                                    >
                                                        <DatePicker
                                                            {...register("toDate", {
                                                                required: fieldValue.leaveType !== 'Special' ? 'error message' : false
                                                            })}
                                                            label='To Date'
                                                            disabled={fieldValue.fromDate !== '' ? false : true}
                                                            format='DD/MM/YYYY'
                                                            value={dayjs(fieldValue.toDate)}
                                                            minDate={minDateOfToDate}
                                                            shouldDisableDate={shouldDisableDate}
                                                            onChange={(e) => handleField(e, 'toDate', 'date')}
                                                        />

                                                    </DemoContainer>
                                                </LocalizationProvider>
                                            </FormControl>
                                        )}
                                    </div>

                                </>}
                                {(fieldValue.session === "Half Day" || fieldValue.session === "Full Day") && <FormControl required sx={{ mt: 1, minWidth: 120 }} fullWidth>

                                    <Controller
                                        name="noOfDays"
                                        control={control}
                                        render={({ field }) => (

                                            <TextField
                                                {...field}
                                                id="outlined-basic"
                                                variant="outlined"
                                                label="No of Days"
                                                disabled={true}
                                                value={fieldValue.noOfDays}
                                            />

                                        )}
                                    />
                                </FormControl>
                                }
                                {
                                    fieldValue.leaveType === 'Medical' && <>
                                        <FormControl required={fieldValue.noOfDays >= 2} sx={{ mt: 1, minWidth: 120, border: "1px solid #C4C4C4", borderRadius: "4px" }} fullWidth>
                                            <InputLabel id="demo-simple-select-required-label">Attachment</InputLabel>
                                            <Controller
                                                name="attachment"
                                                control={control}
                                                render={({ field }) => (
                                                    <div className='fileuplod-field-main-container'>
                                                        <TextField
                                                            {...field}
                                                            id="outlined-basic"
                                                            variant="outlined"
                                                            type="file"
                                                            sx={{ opacity: 0, position: "absolute", width: "100%", height: "100%", top: "0px", left: "0px" }}
                                                            onChange={(e) => handleField(e, "attachment", "file")}
                                                            value={""}
                                                            required={fieldValue.noOfDays >= 2 && file == null}
                                                        />
                                                        <span style={{ marginLeft: "65%", display: "flex" }}>
                                                            {
                                                                fieldValue.attachment !== "" ? <div className='fileuplod-file-label-container'>{fieldValue.attachment}</div> : ""
                                                            }
                                                            <AttachFileIcon
                                                                sx={{ marginTop: "15px", marginLeft: "auto", }}
                                                            />
                                                        </span>

                                                    </div>
                                                )}
                                            />
                                        </FormControl>
                                    </>}
                                <FormControl required sx={{ mt: 1, minWidth: 120, minHeight: '20px' }} fullWidth>
                                    <Controller
                                        name="reasonForLeave"
                                        control={control}
                                        render={({ field }) => (
                                            <TextareaAutosize
                                                {...field}
                                                {...register("reasonForLeave", {
                                                    required: 'error message'
                                                })}
                                                value={fieldValue.reasonForLeave}
                                                aria-label="empty textarea"
                                                minRows={5}
                                                maxRows={5}
                                                maxLength={200}
                                                style={{ padding: '4px', paddingLeft: '12px' }}
                                                placeholder="Reason*(200 Character Max)"
                                                onChange={(e) => handleField(e, "reasonForLeave")}
                                            />
                                        )}
                                    />
                                </FormControl>

                            </div >
                            <div className={`leave-application-button-container ${props.isFullPage ? 'full-page-button' : ''}`}>
                                <ButtonWrapper title='submit' id='submit-button' variant='contained' type='submit' />
                            </div>
                        </div>
                        </div>
                    </div>
                </form >


            </div >
        </>
    )
}

export default LeaveApplication